import * as React from 'react';

import { useEnterpriseAdminPermissions } from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsProvider';
import { AccessDenied, Header } from 'bundles/enterprise-ui';

const withEnterpriseAdminRolePermissionsRequired =
  (Component: React.ComponentType) =>
  ({ ...props }) => {
    const { currentRequiredPermission, hasPermission } = useEnterpriseAdminPermissions();

    const hasMetRequiredPermission = currentRequiredPermission && hasPermission(currentRequiredPermission);

    if (currentRequiredPermission && !hasMetRequiredPermission) {
      return (
        <div>
          <Header />
          <AccessDenied />
        </div>
      );
    }

    return <Component {...props} />;
  };

export default withEnterpriseAdminRolePermissionsRequired;
